import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.number.constructor.js";
import { ChatTypeEnum } from "@/apis/model/ChatTypeEnum";
import { convertFromChatTypeEnum } from "@/apis/model/convertFromChatTypeEnum";
import { assert } from "./assert";

var convertToChatTypeEnum = function () {
  var chatTypeReverseMap = {};
  Object.values(ChatTypeEnum).forEach(function (t) {
    var n = convertFromChatTypeEnum(t);
    chatTypeReverseMap[n] = t;
  });
  return function (n) {
    assert(n && n > 0, "n falsy or non-positive");
    var chatType = chatTypeReverseMap[n];
    assert(chatType, "chatType look up failed for n: " + n);
    return chatType;
  };
}();

var FHTChatId =
/** @class */
function () {
  function FHTChatId(_chatType, _chatServerId) {
    this._chatType = _chatType;
    this._chatServerId = _chatServerId;
    assert(_chatType, "_chatType falsy");
    assert(typeof _chatServerId === "number", "_chatServerId not number");
    assert(ChatTypeEnum[_chatType], "invalid ChatType: " + _chatType);
    assert(_chatServerId > 0, "non-positive _chatServerId");
  }

  Object.defineProperty(FHTChatId.prototype, "chatType", {
    get: function get() {
      return this._chatType;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FHTChatId.prototype, "chatServerId", {
    get: function get() {
      return this._chatServerId;
    },
    enumerable: false,
    configurable: true
  });

  FHTChatId.prototype.encode = function () {
    var t = convertFromChatTypeEnum(this._chatType);
    assert(typeof t === "number", "t gotta be number");
    return t + "_" + this._chatServerId;
  };

  FHTChatId.decode = function (encodedChatId) {
    assert(encodedChatId, "encodedChatId not value");
    assert(typeof encodedChatId === "string", "encodedChatId must be string");
    var tokens = encodedChatId.split("_");
    assert(tokens.length === 2, "encodedChatId tokens not of length 2: " + encodedChatId);
    var n = Number(tokens[0]);
    assert(n, "tokens[0] is not number");
    var chatType = convertToChatTypeEnum(n);
    assert(chatType, "chatType not value");
    var chatServerId = Number(tokens[1]);
    assert(chatServerId > 0, "chatServerId not greater than 0");
    return FHTChatId.of(chatType, chatServerId);
  };

  FHTChatId.prototype.equals = function (other) {
    assert(other, "other falsy");
    assert(other instanceof FHTChatId, "other falsy");
    return this.chatType === other.chatType && this.chatServerId === other.chatServerId;
  };

  FHTChatId.of = function (chatType, chatServerId) {
    return new FHTChatId(chatType, chatServerId);
  };

  FHTChatId.fromPersonalChat = function (chatServerId) {
    return new FHTChatId(ChatTypeEnum.Personal, chatServerId);
  };

  FHTChatId.fromTouristChat = function (chatServerId) {
    return new FHTChatId(ChatTypeEnum.Tourist, chatServerId);
  };

  return FHTChatId;
}();

export { FHTChatId };